import React from 'react';
import failedIcon from '../../assets/failedIcon.png';
import dash from '../../assets/dash.png';
import copyicon from '../../assets/copyicon.png';
import {Link} from 'react-router-dom'

export default function Failed({setOrderAlert}){

    setOrderAlert({value:false, result:false})
    return(
        <div className='AlertBackground2'>
            <center>
                <img src={failedIcon} alt="successful image"/>
                <div className='successfultitle'>
                Payment Failed
                </div>
                <img src={dash} alt="dash icons" className="dash"/>
                <div className='failedDetails'>
                Try Again
                </div>
            </center>
        </div>
    )
}